import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { isInquiryReadonlyPreview } from '@framework/common-web/ui/inquiry/isInquiryReadonlyPreview.ts';
import { SubmissionLogic } from '@framework/frontoffice-submission/submission/SubmissionLogic.ts';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { Button } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { useTranslation } from 'react-i18next';
import { useCreateSubmissionAndLinks } from '../hooks/useCreateSubmissionAndLinks.ts';

export interface ICreateRequestButtonProps {
  inquiry?: TipoDomandaDTO;
}

/**
 * Bottone della lista delle domande che permette di creare una nuova Richiesta.
 * Una volta creata fa in automatico il redirect alla pagina di compilazione.
 */
export function CreateSubmissionButton(props: ICreateRequestButtonProps) {
  const { inquiry } = props;
  const { t } = useTranslation();
  const isUniqueRequest = inquiry?.flRichiestaUnivoca;

  const { handleClick, loading } = useCreateSubmissionAndLinks(inquiry?.id);

  return (
    <>
      <Button
        type="primary"
        block
        size="large"
        onClick={() => {
          handleClick();
        }}
        loading={loading}
        disabled={!SubmissionLogic.canCreateSubmission(inquiry)}
      >
        {/* In anteprima di sola lettura si apre un fac-simile,
        non la compilazione: il testo configurato in copertina non si applica */}
        {isInquiryReadonlyPreview(inquiry)
          ? t(
              'domanda.bottone-crea-richiesta.visualizza-anteprima',
              'Visualizza anteprima',
            )
          : (inquiry?.copertina?.pulsanteAccesso ??
            t(
              'domanda.bottone-crea-richiesta.vai-alla-compilazione',
              'Vai alla compilazione',
            ))}
      </Button>
      {isUniqueRequest && (
        <>
          <VerticalSpace size={8} />
          <Paragraph>
            {t(
              'domanda.bottone-compilare-una-richiesta-per-titolare',
              'È possibile compilare una sola richiesta per titolare per questa domanda',
            )}
          </Paragraph>
        </>
      )}
    </>
  );
}
